import React from 'react';
import { createPortal } from 'react-dom';
import { Icons } from './icons';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string | undefined;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
const Modal = ({ isOpen, onClose, title, children, size = 'md' }: ModalProps) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'w-full max-w-sm',
    md: 'w-full max-w-md',
    lg: 'w-full max-w-3xl',
    xl: 'w-full max-w-5xl',
  };

  const handleBackdropClick = (e: React.MouseEvent): void => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const content = (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-backdrop backdrop-blur-sm p-4' onClick={handleBackdropClick} role='dialog' aria-modal='true'>
      <div className={`bg-card text-card-foreground border border-border rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto ${sizeClasses[size]}`}>
        <div className='flex justify-between items-center mb-4 p-6 pb-0'>
          {title && <h2 className='text-xl font-bold'>{title}</h2>}
          <button className='ml-auto p-2 hover:bg-muted rounded-full transition-colors' onClick={onClose} aria-label='Close modal'>
            <Icons.X className='h-5 w-5' />
          </button>
        </div>
        <div className='p-6 pt-4'>{children}</div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default Modal;
